import axios from 'axios';

export function financeDashboardErrorMessage(error: unknown): string {
  if (!axios.isAxiosError(error)) {
    return 'Couldn’t load the finance dashboard. Try again.';
  }
  if (!error.response) {
    return 'Can’t reach the finance API. Check your connection, then try again.';
  }
  switch (error.response.status) {
    case 401:
      return 'Your session expired. Sign in again, then reload this page.';
    case 403:
      return 'You don’t have permission to view finance data.';
    case 404:
      return 'Finance data isn’t available yet. The API may still be updating — try again in a few minutes.';
    default:
      if (error.response.status >= 500) {
        return 'The finance service hit a problem. Try again shortly.';
      }
      return 'Couldn’t load the finance dashboard. Try again.';
  }
}
